import { Content } from '../../types';

export const koSurinNueaContent: Content = {
  title: 'איי סורין (Ko Surin Nuea) - גן עדן טרופי בים אנדמן',
  imageUrl: '/images/thailand/ko-surin-nuea/ko-surin-nuea-wide.jpeg',
  introduction:
    'איי סורין, הינם קבוצה בת חמישה איים קסומים בעלי יופי עוצר נשימה, השוכנים בים אנדמן, כ-60 ק"מ מחופי קאו לאק שבמחוז פנג נה, תאילנד. האיים משתייכים לשמורת הפארק הלאומי Mu Ko Surin ונחשבים לאחד מאתרי הצלילה והשנורקלינג היפים ביותר בתאילנד, לצד אווירה אותנטית ורוגע טבעי נדיר.',
  sections: [
    {
      title: 'יופיים הייחודי של איי סורין',
      type: 'text',
      content:
        'איי סורין ידועים במימיהם הצלולים בצבע טורקיז עמוק, המאפשרים ראות מעולה לעומקים ניכרים, לצד חופים לבנים רכים וכפרים מסורתיים. ייחודם נובע מהשימור הקפדני שלהם, מה שמעניק חוויה טבעית בלתי מתויירת מידיי. השוניות באיים מארחות עולם תת-ימי עשיר וצבעוני עם דגים טרופיים, כרישים ידידותיים, צבי ים ואלמוגים מהמרהיבים שבתאילנד.',
    },
    {
      title: 'פעילויות באיים',
      type: 'sub-headers',
      description: 'הפעילויות העיקריות באיים כוללות:',
      content: [
        {
          subtitle: 'צלילה ושנורקלינג',
          text: 'אחד היעדים הטובים ביותר בתאילנד לפעילויות אלו, עם מים צלולים ושוניות אלמוגים מדהימות.',
        },
        {
          subtitle: 'טיולי טבע ויערות גשם',
          text: 'האיים מציעים מסלולי הליכה קצרים דרך הצמחייה העבותה, עם הזדמנות לפגוש חיות בר ייחודיות.',
        },
        {
          subtitle: 'ביקור בכפר צועני הים Moken',
          text: 'קהילה מסורתית שחיה באזור במשך מאות שנים, עם אורח חיים ייחודי המחובר לטבע ולים.',
        },
        {
          subtitle: 'רביצה על החופים הלבנים',
          text: 'חוויית שלווה אמיתית למחפשים רוגע למול הנופים הטרופיים.',
        },
      ],
    },
    {
      title: 'תיירות בת-קיימא ומיעוט מבקרים',
      type: 'text',
      content:
        'בניגוד לאיי סימילאן הפופולריים והמוכרים יותר, איי סורין פחות מתויירים, מה שמאפשר שמירה על האותנטיות שלהם ועל השקט והרוגע הטבעי. כדי להגן על הסביבה, מספר המבקרים היומי מוגבל, ולכן, במיוחד בתקופות החגים המקומיים, מומלץ להזמין את הטיול מראש.',
    },
    {
      title: 'מתי ואיך מגיעים לאיי סורין?',
      type: 'text',
      content:
        'בדומה לאיי סימילאן, האיים פתוחים למבקרים רק בעונה היבשה - בדרך כלל בין אמצע אוקטובר לאמצע מאי. תאריכי הפתיחה והסגירה המדוייקים, משתנים מדי שנה בהתאם למזג האוויר.',
    },
    {
      title: 'דרכי הגעה',
      type: 'sub-headers',
      description: 'ישנן מספר אפשרויות להגיע לאיי סורין:',
      content: [
        {
          subtitle: 'שייט מקאו לאק',
          text: 'שייט המהיר (Speed Boat), האורך מעט יותר משעה לכל כיוון.',
        },
        {
          subtitle: 'טיולים מאורגנים מפוקט',
          text: 'כוללים נסיעה יבשתית של כשעתיים לקאו לאק ומשם שייט לאיים.',
        },
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, איי סורין מציעים חוויה אותנטית, טבעית ושלווה הרחק מהמוני התיירים. עם חופים לבנים, מים צלולים, עולם תת-ימי מדהים ותרבות מקומית מרתקת - אין ספק שהם אחד היעדים הקסומים ביותר בתאילנד לכל חובבי הטבע והים.',
    },
  ],
};
